module.exports = __webpack_public_path__ + "static/media/W18-0610_AW_SpicyGuac_LTO_Fries_desktop_hero_2396x1473_FR.8061e886.jpg";